<template>
    <section class="padm-card" v-if="isOneAdminAnswer()">
        <div class="padm-header">
            <i class="fal fa-lock"></i>
            <h2>{{ $t('post.page.information.admin') }}</h2>
        </div>
        <div class="padm-body">
            <div v-for="answer in post.answers" :key="answer.id">
                <div class="padm-item" v-if="answer.hidden === 1">
                    <component
                        :medias="post.medias"
                        :is="resolveComponent(answer.name)"
                        :value="answer"
                        :post="post"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MapPostCard from '@/components/Model/Map/MapPostCard'
import ClassicAttribute from './Attribute/ClassicAttribute'
import CategoryAttribute from './Attribute/CategoryAttribute'
import FileUploadAttribute from './Attribute/FileUploadAttribute'
import CheckboxAttribute from './Attribute/CheckboxAttribute'
import AudioAttribute from './Attribute/AudioAttribute'

export default {
    name: 'PostAdmin',
    components: {
        location: MapPostCard,
        category: CategoryAttribute,
        gdpr: CheckboxAttribute,
        smalltext: ClassicAttribute,
        'textarea-field': ClassicAttribute,
        email: ClassicAttribute,
        markdown: ClassicAttribute,
        'file-upload': FileUploadAttribute,
        'audio-field': AudioAttribute,
        rating: ClassicAttribute,
        'select-field': ClassicAttribute,
        checkbox: CheckboxAttribute,
        radio: CheckboxAttribute,
        date: ClassicAttribute,
        datetime: ClassicAttribute,
        number: ClassicAttribute
    },
    props: ['post'],
    methods: {
        resolveComponent(name) {
            if (name === 'audio') return 'audio-field'
            if (name === 'textarea') return 'textarea-field'
            return name
        },
        isOneAdminAnswer() {
            return this.post.answers.filter(answer => answer.hidden === 1).length > 0
        }
    }
}
</script>

<style scoped>
.padm-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.padm-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: #3b82f6;
    color: #fff;
}

.padm-header i {
    font-size: 0.9rem;
    color: #fff !important;
}

.padm-header h2 {
    font-size: 0.95rem;
    font-weight: 700;
    color: #fff;
    margin: 0;
}

.padm-body {
    padding: 0;
}

.padm-item {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
}

.padm-item:last-child {
    border-bottom: none;
}
</style>
